import React, { Component } from 'react';
import { Layout } from 'antd';
import PropTypes from 'prop-types';
import './dashboard.css';

class Sider extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired
  };

  render() {
    return (
      <Layout.Sider className="dashboard-layout__sider" collapsible breakpoint="md">
        <div className="dashboard-layout__sider-placeholder"/>
        { this.props.children }
      </Layout.Sider>
    );
  }
}

Sider.__ANT_LAYOUT_SIDER = true;

export default Sider;



// WEBPACK FOOTER //
// ./src/components/dashboard/sider.js